import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import ManualPaymentHandlingDescription from './manualPaymentHandling_description.mdx';
import ManualPaymentHandlingOnTokenizeSuccess from './manualPaymentHandling_onTokenizeSuccess.mdx';
import ManualPaymentHandlingOnTokenizeError from './manualPaymentHandling_onTokenizeError.mdx';
import ManualPaymentHandlingOnResumeSuccess from './manualPaymentHandling_onResumeSuccess.mdx';
import ManualPaymentHandlingOnResumeError from './manualPaymentHandling_onResumeError.mdx';
import TokenizationCallbacksOnTokenizeDidNotStart from './tokenizationCallbacks_onTokenizeDidNotStart.mdx';
import TokenizationCallbacksOnTokenizeShouldStart from './tokenizationCallbacks_onTokenizeShouldStart.mdx';
import TokenizationCallbacksOnTokenizeStart from './tokenizationCallbacks_onTokenizeStart.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='paymentHandling' subtitle='"AUTO" | "MANUAL"' mdxType="Item">
	<ManualPaymentHandlingDescription mdxType="ManualPaymentHandlingDescription" />
    </Item>
    <Item title='onTokenizeSuccess' subtitle='(data: PaymentMethodTokenData, handler: OnTokenizeSuccessHandler) => void' mdxType="Item">
	<ManualPaymentHandlingOnTokenizeSuccess mdxType="ManualPaymentHandlingOnTokenizeSuccess" />
    </Item>
    <Item title='onTokenizeError' subtitle='(error: PrimerClientError) => void' mdxType="Item">
	<ManualPaymentHandlingOnTokenizeError mdxType="ManualPaymentHandlingOnTokenizeError" />
    </Item>
    <Item title='onResumeSuccess' subtitle='(data: ResumeToken, handler: OnResumeSuccessHandler) => void' mdxType="Item">
	<ManualPaymentHandlingOnResumeSuccess mdxType="ManualPaymentHandlingOnResumeSuccess" />
    </Item>
    <Item title='onResumeError' subtitle='(error: PrimerClientError) => void' mdxType="Item">
	<ManualPaymentHandlingOnResumeError mdxType="ManualPaymentHandlingOnResumeError" />
    </Item>
    <Item title='onTokenizeShouldStart' subtitle='(data: { paymentMethodType: PaymentMethodType }) => boolean' mdxType="Item">
	<TokenizationCallbacksOnTokenizeShouldStart mdxType="TokenizationCallbacksOnTokenizeShouldStart" />
    </Item>
    <Item title='onTokenizeStart' subtitle='() => void' mdxType="Item">
	<TokenizationCallbacksOnTokenizeStart mdxType="TokenizationCallbacksOnTokenizeStart" />
    </Item>
    <Item title='onTokenizeDidNotStart' subtitle='(reason: "TOKENIZATION_DISABLED" | "TOKENIZATION_SHOULD_NOT_START") => void' mdxType="Item">
	<TokenizationCallbacksOnTokenizeDidNotStart mdxType="TokenizationCallbacksOnTokenizeDidNotStart" />
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      